import { jsx } from "react/jsx-runtime";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { validateTidalLicense } from "../../base/index.js";
function LocalOfferOutlined(props) {
  return /* @__PURE__ */ jsx(
    LocalOfferOutlinedIcon,
    {
      "data-testid": "LocalOfferOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "LocalOfferOutlined",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
LocalOfferOutlined.tidalIconMeta = {
  categories: "miscellaneous",
  name: "LocalOfferOutlined"
};
validateTidalLicense();
export {
  LocalOfferOutlined
};
//# sourceMappingURL=LocalOfferOutlined.js.map
